import { useEffect, useState } from 'react';
import api from '../services/api';

/**
 * What needs this person's attention (GET /me/pending): the chips on Home and the bell's number. Home
 * re-fetches every time it mounts, which happens on every visit, so a chip clears once dealt with. The
 * Navbar mounts once per session (it wraps every route), so it is given `refreshKey` — pass the current
 * route path — to refetch on every in-app navigation too; otherwise the bell would freeze at its first
 * value for the rest of the session, including after the thing it counted was dealt with elsewhere.
 */
export function usePendingCounts(refreshKey) {
    const [pending, setPending] = useState(null);
    useEffect(() => {
        let live = true;
        api.get('/me/pending').then(r => { if (live) setPending(r.data); }).catch(() => { if (live) setPending({}); });
        return () => { live = false; };
    }, [refreshKey]);
    return pending || {};
}
